import { Location } from 'react-router';

export enum ReceptionAppScopes {
  LOGIN = 'IMAGE_UPLOAD_APP',
}

export interface ExtendedLocation extends Omit<Location, 'state'> {
  state?: {
    from?: Location;
  };
}
